import { GOV_UK_URL, REVENUE_IE_URL } from '@propertypal/shared/src/constants/externalLinks';
import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { Property } from '@propertypal/shared/src/types/property';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { Container, LinkText, Title } from './RelatedLinks.style';

interface Props {
  title?: string;
  property: Property;
}

const RelatedLinks: FunctionComponent<Props> = (props) => {
  const hasStampDutyComplex = props.property.keyInfo?.some((info) => info.key === 'STAMP_DUTY_COMPLEX');
  const hasRatesInfo = props.property.keyInfo?.some((info) => info.key === 'RATES');
  const hasStampDutySimple = props.property.keyInfo?.some((info) => info.key === 'STAMP_DUTY_SIMPLE');

  const trackAgentLandingClick = async () => {
    if (props.property.account) {
      await axios(
        {
          method: 'POST',
          url: `${API_URL}/event`,
          data: {
            eventType: 'AGENT_LANDING_CLICK',
            property: props.property.id,
            accountNumber: props.property.account.accountNumber,
          },
        },
        undefined,
      );
    }
  };

  return (
    <Container>
      {props.title && <Title>{props.title}</Title>}

      {props.property.relatedSearches &&
        Object.keys(props.property.relatedSearches).map((key, index, keys) => (
          <span key={key}>
            {/* @ts-ignore */}
            <Link href={props.property.relatedSearches[key]} passHref prefetch={false}>
              <LinkText onClick={() => index + 1 === keys.length && trackAgentLandingClick()}>{key}</LinkText>
            </Link>
            {index + 1 < keys.length ? ' | ' : ' '}
          </span>
        ))}

      {hasRatesInfo && (
        <span data-testid="rates-information">
          * Rates information is provided for guidance purposes only, as the information source is subject to change.
          Please check the LPSNI website for further detail.
        </span>
      )}

      {hasStampDutySimple && (
        <span data-testid="stamp-duty-roi">
          * Stamp Duty information is provided for guidance purposes only. Please check the Office of the Revenue
          Commissioners website for further details. <LinkText href={REVENUE_IE_URL}>({REVENUE_IE_URL})</LinkText>
        </span>
      )}

      {hasStampDutyComplex && (
        <span>
          ** Stamp Duty Land Tax information is provided for guidance purposes only. Please check the UK Government
          website for further details <LinkText href={GOV_UK_URL}>(www.gov.uk)</LinkText>. Higher amount applies when
          purchasing as buy to let or as an additional property.
        </span>
      )}
    </Container>
  );
};

export default React.memo(RelatedLinks);
